import React, { useState } from 'react';
import './App.css';
import './fonts.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <div className="App">
      {/* Dark Veil Effect */}
      <div className="dark-veil"></div>
      
      {/* Header */}
      <header className="header">
        <div className="container">
          {/* Logo */}
          <div className="logo">
            <img src="/images/logo 1.png" alt="Ecomverse Logo" className="logo-image" />
          </div>

          {/* Navigation */}
          <nav className="nav">
            <a href="/" className="nav-link">Ecomverse</a>
            <a href="#features" className="nav-link">Özellikler</a>
            <a href="#pricing" className="nav-link">Abonelik</a>
            <a href="#testimonials" className="nav-link">Referanslar</a>
            <a href="#faq" className="nav-link">Sık Sorulanlar</a>
            <a href="#pricing" className="nav-link">Ödeme</a>
          </nav>

          {/* Menu Button */}
          <div className="menu-btn" onClick={toggleMenu}>
            <div className="menu-lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Dropdown Menu */}
          {isMenuOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-content">
                <a href="/terms" className="dropdown-item">Kullanım Koşulları</a>
                <a href="/privacy" className="dropdown-item">Gizlilik Politikası</a>
                <button 
                  className="shine-btn dropdown-shine-btn"
                  onClick={() => window.open('https://whop.com/ecomversee/ecomverse-6e/', '_blank')}
                >
                  Ecomverse'a Katıl
                </button>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Overlay */}
      {isMenuOpen && <div className="overlay" onClick={toggleMenu}></div>}

      {/* Main Content */}
      <main className="main">
        <div className="container-main">
          <div className="hero-content">
            <h1 className="hero-title">
              Zenginlik için torpil gerekmez.<br />
              Bilgiye önce ulaşan kazanır.
            </h1>
            <p className="hero-subtitle">
              E-ticarete dair tüm araçlar ve dersler tek bir yerde.<br />
              Ecomverse sınırlı sayıda koltuk içeriyor ve kontenjan doldukça fiyatlar artacak.
            </p>
            
            {/* Video Player */}
            <div className="video-container">
              <div className="video-player custom-video-player">
                <video 
                  controls 
                  width="100%" 
                  height="100%"
                  poster="/images/video-thumbnail.jpg"
                  className="custom-video"
                >
                  <source src="/videos/ecomverse-demo.mp4" type="video/mp4" />
                  <source src="/videos/ecomverse-demo.webm" type="video/webm" />
                  Tarayıcınız video oynatmayı desteklemiyor.
                </video>
              </div>
              
              {/* Join Button */}
              <div className="join-button-container">
                <button 
                  className="shine-btn"
                  onClick={() => window.open('https://whop.com/ecomversee/ecomverse-6e/', '_blank')}
                >
                  Aramıza Katılın!
                </button>
              </div>

              {/* Sliding Logos Section */}
              <div className="logos-section">
                <p className="logos-title">Desteğimizle başarıya ulaşmış sayısız marka.</p>
                <div className="logos-slider">
                  <div className="logos-track">
                    <div className="logo-item">
                      <img src="/images/Akme.tr_kopyası_kopyası-removebg-preview 1 1.png" alt="Akme" className="logo-akme" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group.png" alt="Lumipage" className="logo-lumipage" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group-1.png" alt="Otowashing" className="logo-otowashing" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group-2.png" alt="Paticimispa" className="logo-paticimispa" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group-3.png" alt="Kitora" className="logo-kitora" />
                    </div>
                    {/* Duplicate for seamless loop */}
                    <div className="logo-item">
                      <img src="/images/Akme.tr_kopyası_kopyası-removebg-preview 1 1.png" alt="Akme" className="logo-akme" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group.png" alt="Lumipage" className="logo-lumipage" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group-1.png" alt="Otowashing" className="logo-otowashing" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group-2.png" alt="Paticimispa" className="logo-paticimispa" />
                    </div>
                    <div className="logo-item">
                      <img src="/images/Mask group-3.png" alt="Kitora" className="logo-kitora" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Why Are You Here Section */}
              <div className="why-section" id="features">
                <div className="why-header">
                  <div className="why-badge">
                    <span className="star-icon">⭐</span>
                    <span>Amaç</span>
                  </div>
                  <h2 className="why-title">Neden Buradasınız?</h2>
                  <p className="why-subtitle">317 saatlik süslü cümlelere gerek yok, size kattığımız değer basit ve nettir.</p>
                </div>

                <div className="why-cards">
                  <div className="why-card">
                    <div className="card-icon">
                      <img src="/images/cMQC9rzRPH6NaahZRQC8lUWqYfgfU.png" alt="AI" />
                    </div>
                    <h3 className="card-title">Sıfırdan Shopify İnşası</h3>
                    <p className="card-description">Shopify'a dair öğrenmen gereken her şeyi öğretiyoruz.</p>
                  </div>

                  <div className="why-card">
                    <div className="card-icon">
                      <img src="/images/JLcXSHuie3ywKZ9Bmw29G78is0Q.png" alt="Shopify" />
                    </div>
                    <h3 className="card-title">Yapay Zeka Kullanımı</h3>
                    <p className="card-description">E-Ticaret'te yapay zekayı en etkili biçimde kullanmayı öğretiyoruz.</p>
                  </div>

                  <div className="why-card">
                    <div className="card-icon">
                      <img src="/images/wGEQkC2yZeKC3lIMxVDCjHhwro8.png" alt="Meta" />
                    </div>
                    <h3 className="card-title">Meta Ads Ölçekleme</h3>
                    <p className="card-description">Metaya dair öğrenmen gereken her şeyi öğretiyoruz.</p>
                  </div>
                </div>

                {/* Join Button */}
                <div className="why-join-button-container">
                  <button 
                    className="shine-btn"
                    onClick={() => window.open('https://whop.com/ecomversee/ecomverse-6e/', '_blank')}
                  >
                    Aramıza Katılın!
                  </button>
                </div>
              </div>

              {/* What Does Ecomverse Add Section */}
              <div className="ecomverse-adds-section">
                <div className="ecomverse-adds-header">
                  <div className="ecomverse-adds-badge">
                    <span className="calendar-icon">📅</span>
                    <span>Eğitim</span>
                  </div>
                  <h2 className="ecomverse-adds-title">Ecomverse Size Ne Katıyor?</h2>
                  <p className="ecomverse-adds-subtitle">
                    Belki 4 yılını üniversiteye verdin ve hâlâ iş arıyorsun.<br />
                    Biz 4 haftada kendi markanı kurmanı öğretiyoruz.
                  </p>
                </div>

                <div className="ecomverse-adds-content">
                  {/* Left Cards */}
                  <div className="ecomverse-adds-left">
                    <div className="ecomverse-add-card">
                      <div className="card-icon-small">
                        <img src="/images/Op1jVGjnW3PRkbAtu2F6pwso.png" alt="AI Icon" />
                      </div>
                      <h3 className="card-title-small">Yapay Zeka</h3>
                      <p className="card-description-small">
                        Yapay Zeka'yı kullanmayı öğrenin.
                      </p>
                      <p className="card-description-small">
                        İşlerinizi 10 kat daha verimli yapın.
                      </p>
                    </div>

                    <div className="ecomverse-add-card">
                      <div className="card-icon-small">
                        <img src="/images/fHXLQ8EOcfv7WezBAqqUtj7A4Y.png" alt="Fitness Icon" />
                      </div>
                      <h3 className="card-title-small">Fitness</h3>
                      <p className="card-description-small">
                        Zihnini ve bedenini aynı anda geliştir.
                      </p>
                      <p className="card-description-small">
                        Sağlıklı ve fit bir vücuda sahip olun ve çalışmalarınızı bir üst düzeye çıkarın.
                      </p>
                    </div>
                  </div>

                  {/* Center Phone Mockup */}
                  <div className="ecomverse-adds-center">
                    <div className="phone-image">
                      <img src="/images/Group 1.png" alt="Phone Mockup" />
                    </div>
                  </div>

                  {/* Right Cards */}
                  <div className="ecomverse-adds-right">
                    <div className="ecomverse-add-card">
                      <div className="card-icon-small">
                        <img src="/images/v4hrohrK6OKw6kG9cdE891vyTm8.png" alt="E-commerce Icon" />
                      </div>
                      <h3 className="card-title-small">E-Ticaret</h3>
                      <p className="card-description-small">
                        Marka kurmayı, viral reklamlar oluşturmayı ve satış yapmayı öğrenin.
                      </p>
                      <p className="card-description-small">
                        Bu sayede uyurken bile para kazanın ve özgürlüğe kavuşun.
                      </p>
                    </div>

                    <div className="ecomverse-add-card">
                      <div className="card-icon-small">
                        <img src="/images/8CTE1EIo5A0nW0MI7R6ASfYkl68.png" alt="Network Icon" />
                      </div>
                      <h3 className="card-title-small">Network</h3>
                      <p className="card-description-small">
                        Sizinle beraber sürekli olarak çalışacak ve faydalı insanlarla tanışın.
                      </p>
                      <p className="card-description-small">
                        Kazananların arasında olmak, seni de kazanan yapar.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Free Memberships Section */}
              <div className="free-memberships-section">
                <div className="free-memberships-header">
                  <div className="free-memberships-badge">
                    <span className="package-icon">📦</span>
                    <span>Ek Paketler</span>
                  </div>
                  <h2 className="free-memberships-title">Bedava Üyelikler</h2>
                  <p className="free-memberships-subtitle">Ecomverse'a Özel Bedava Üyelikler.</p>
                </div>

                <div className="new-memberships-grid">
                  <div className="new-membership-card tools-card">
                    <div className="card-image">
                      <img src="/images/tasarım1.png" alt="Premium Araçlar" />
                    </div>
                    <div className="card-content">
                      <div className="card-badge">
                        <img src="/images/CJFVx4lqVbUIgXPLOIEOzPqEmI.png" alt="Premium" style={{width: '20px', height: '20px'}} />
                        <span>+3000$ Üyelikler</span>
                      </div>
                      <p className="card-description">Premium araçlara ekstra ücret ödemeyin.</p>
                      <p className="card-details">
                        Ecomverse üyeliğiyle ChatGPT Pro, Canva Pro, Dropship.io, gibi platformlara erişim sağlayın.
                      </p>
                    </div>
                  </div>

                  <div className="new-membership-card fitness-card">
                    <div className="card-image">
                      <img src="/images/tasarım2.png" alt="Sağlık ve Fitness" />
                    </div>
                    <div className="card-content">
                      <div className="card-badge">
                        <img src="/images/vSbH3QGZINbHlCUYAALZSzTNWk.png" alt="Fitness" style={{width: '20px', height: '20px'}} />
                        <span>Sağlık Ve Fitness</span>
                      </div>
                      <p className="card-description">Zihinsel başarı fiziksel ve mental sağlıkla başlar.</p>
                      <p className="card-details">
                        Fitness, beslenme ve yaşam dengesine dair özel içeriklerle verimini artır, tempoyu koru.
                      </p>
                    </div>
                  </div>

                  <div className="new-membership-card shopify-card">
                    <div className="card-image">
                      <img src="/images/tasarım3.png" alt="Shopify Temaları" />
                    </div>
                    <div className="card-content">
                      <div className="card-badge">
                        <img src="/images/t9zAAKGubA1gMErjWQbQ5dfgghgRA.png" alt="Shopify" style={{width: '20px', height: '20px'}} />
                        <span>Shopify Temaları</span>
                      </div>
                      <p className="card-description">Sıfırdan tema oluşturmakla zaman harcamayın.</p>
                      <p className="card-details">
                        Halihazırda başarısı kanıtlanmış temaları ücretsiz kullanın ve ayarlarını öğrenin.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Features Section */}
              <div className="additional-features-section">
                <div className="additional-features-grid">
                  <div className="feature-card">
                    <div className="feature-image">
                      <img src="/images/tasarım4.png" alt="Mağaza Analizleri" />
                    </div>
                    <div className="feature-content">
                      <div className="feature-badge">
                        <img src="/images/J7RmTsRRonSSEFdA8S7qs3xL2FI.png" alt="Analytics" style={{width: '20px', height: '20px'}} />
                        <span>Mağaza Analizleri</span>
                      </div>
                      <p className="feature-description">
                        Tahmine değil verilere göre hareket et.
                      </p>
                    </div>
                  </div>

                  <div className="feature-card">
                    <div className="feature-image">
                      <img src="/images/tasarım5.png" alt="Deneyimli Mentörler" />
                    </div>
                    <div className="feature-content">
                      <div className="feature-badge">
                        <img src="/images/KrU5Sm0T72khx1WnbEd67ZnybJE.png" alt="Mentors" style={{width: '20px', height: '20px'}} />
                        <span>Deneyimli Mentörler</span>
                      </div>
                      <p className="feature-description">
                        Sektörde başarıya ulaşmış mentörlerle birebir iletişim kur.
                      </p>
                    </div>
                  </div>

                  <div className="feature-card">
                    <div className="feature-image">
                      <img src="/images/tasarım6.png" alt="Ecomverse Çekilişler" />
                    </div>
                    <div className="feature-content">
                      <div className="feature-badge">
                        <img src="/images/2KwOZz8MWr1fN9LEMqGptBDbe1M.png" alt="Giveaways" style={{width: '20px', height: '20px'}} />
                        <span>Ecomverse Çekilişler</span>
                      </div>
                      <p className="feature-description">
                        Şansınızı deneyin ve çeşitli ödüller kazanın.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Pricing Section */}
        <div className="pricing-section" id="pricing">
          <div className="container-main">
            <div className="pricing-header">
              <div className="pricing-badge">
                <span className="crown-icon">👑</span>
                <span>Abonelik</span>
              </div>
              <h2 className="pricing-title">Seçimini Yap</h2>
              <p className="pricing-subtitle">
                Kazanç, odaklanmakla mümkündür.<br />
                Onu doğru bilgiyle doğru işe odaklandığınızda yaratırsınız.
              </p>
              <button className="pricing-cta-btn">Seçimini Yap</button>
            </div>

            <div className="pricing-cards">
              <div className="pricing-card ecomverse-card">
                <div className="pricing-card-header">
                  <div className="pricing-label">Ecomverse / Ömür Boyu</div>
                  <h3 className="pricing-card-title">Ecomverse</h3>
                  <div className="pricing-features">
                    <p>Kendi markanı kur.</p>
                    <p>Yenilikçi kal ve hayatını değiştir.</p>
                    <p>Modern beceriler edin.</p>
                    <p>Çağa ayak uydur.</p>
                    <p>Ecomverse'a katıl.</p>
                  </div>
                  <button 
                    className="shine-btn"
                    onClick={() => window.open('https://whop.com/ecomversee/ecomverse-6e/', '_blank')}
                  >
                    Son Şans
                  </button>
                </div>
                
                <div className="pricing-features-list">
                  <h4 className="features-title">Nelere Erişebilirsiniz?</h4>
                  <div className="feature-item">
                    <img src="/images/55fmjBtSJ5KITLoOmKA2KYcj64.svg" alt="Check" className="check-icon" />
                    <span>Hedefi Olan İnsanlarla Tanış</span>
                  </div>
                  <div className="feature-item">
                    <img src="/images/55fmjBtSJ5KITLoOmKA2KYcj64.svg" alt="Check" className="check-icon" />
                    <span>Kendi İşini Kur Ve Özgür Ol</span>
                  </div>
                  <div className="feature-item">
                    <img src="/images/55fmjBtSJ5KITLoOmKA2KYcj64.svg" alt="Check" className="check-icon" />
                    <span>Yapay Zeka Kullanmayı Öğren</span>
                  </div>
                  <div className="feature-item">
                    <img src="/images/55fmjBtSJ5KITLoOmKA2KYcj64.svg" alt="Check" className="check-icon" />
                    <span>Servet Yaratmaya Başla</span>
                  </div>
                  <div className="feature-item">
                    <img src="/images/55fmjBtSJ5KITLoOmKA2KYcj64.svg" alt="Check" className="check-icon" />
                    <span>Özel Toplantılara Katıl</span>
                  </div>
                  <div className="feature-item">
                    <img src="/images/55fmjBtSJ5KITLoOmKA2KYcj64.svg" alt="Check" className="check-icon" />
                    <span>Vücudunu Geliştirmeyi Öğren</span>
                  </div>
                </div>
              </div>

              <div className="pricing-card ruhunla-card">
                <div className="pricing-card-header">
                  <div className="pricing-label">İş Bul / Kısa Vadeli</div>
                  <h3 className="pricing-card-title">Ruhunla Öde</h3>
                  <div className="pricing-features">
                    <p>Geleneksel yolu izleyin.</p>
                    <p>Sevmediğiniz bir işe başlayın.</p>
                    <p>Aptal bir patrona yıllarınızı yatırın,</p>
                    <p>böylece 50 yıl içinde emekli</p>
                    <p>olabilirsiniz.</p>
                  </div>
                  <button 
                    className="shine-btn ruhunla-shine-btn"
                    onClick={() => window.open('https://isinolsun.com/is-ilanlari?kw=Burger%20King', '_blank')}
                  >
                    Burgerleri Çevir
                  </button>
                </div>
                
                <div className="pricing-features-list">
                  <h4 className="features-title">Hayatınız Nasıl İlerleyecek?</h4>
                  <div className="feature-item disabled">
                    <img src="/images/Ej8l59R9fYjXX47NmFf4J9ZOwU.svg" alt="Cross" className="cross-icon" />
                    <span>Sıkıcı Hayatına Devam Et</span>
                  </div>
                  <div className="feature-item disabled">
                    <img src="/images/Ej8l59R9fYjXX47NmFf4J9ZOwU.svg" alt="Cross" className="cross-icon" />
                    <span>Patronunun Ağız Kokusunu Çek</span>
                  </div>
                  <div className="feature-item disabled">
                    <img src="/images/Ej8l59R9fYjXX47NmFf4J9ZOwU.svg" alt="Cross" className="cross-icon" />
                    <span>Saatlerce Çalış Ve Zaman Kaybet</span>
                  </div>
                  <div className="feature-item disabled">
                    <img src="/images/Ej8l59R9fYjXX47NmFf4J9ZOwU.svg" alt="Cross" className="cross-icon" />
                    <span>Enflasyona Yenik Düş</span>
                  </div>
                  <div className="feature-item disabled">
                    <img src="/images/Ej8l59R9fYjXX47NmFf4J9ZOwU.svg" alt="Cross" className="cross-icon" />
                    <span>Boş İnsanlarla Takıl</span>
                  </div>
                  <div className="feature-item disabled">
                    <img src="/images/Ej8l59R9fYjXX47NmFf4J9ZOwU.svg" alt="Cross" className="cross-icon" />
                    <span>Sağlıksız Bir Hayat Geçir</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Testimonials Section */}
        <div className="testimonials-section" id="testimonials">
          <div className="container-main">
            <div className="testimonials-header">
              <div className="testimonials-badge">
                <span className="users-icon">👥</span>
                <span>Üyelerimiz</span>
              </div>
              <h2 className="testimonials-title">Referanslar</h2>
              <p className="testimonials-subtitle">
                Ecomverse'a katılan mentörlerimizin ve üyelerimizin elde ettiği<br />
                başarılar.
              </p>
            </div>

            <div className="testimonials-slider">
              <div className="testimonials-track">
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Kitap kitlesine hitap eden bir pazarda, Ecomverse'un içerik odaklı pazarlama ve niş topluluk oluşturma stratejileriyle sadık bir okur müşteri kitlesi yarattık."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-21_at_02.31.32-removebg-preview.png" alt="Emre Yıldız" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Emre Yıldız</div><div className="author-title">Lumipage Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#3b82f6"
                        strokeWidth="2"
                        points="0,50 20,45 40,35 60,25 80,20 100,15 120,10 140,8 160,5 180,3 200,2"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Temizlik ürünleri pazarı yoğun rekabet içindeydi. Ecomverse ile doğru pazar analizi ve performans pazarlaması sayesinde markayı sürdürülebilir satış seviyesine taşıdık."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-23_at_00.10.35__1_-removebg-preview.png" alt="Burak Demir" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Burak Demir</div><div className="author-title">Otowashing Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#10b981"
                        strokeWidth="2"
                        points="0,55 20,52 40,48 60,42 80,35 100,28 120,22 140,18 160,12 180,8 200,5"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Kozmetik sektöründe, Ecomverse'un trend yakalama ve sürdürülebilir pazarlama stratejileriyle hem güven veren hem de karlı bir marka inşa ettik."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-23_at_00.10.35-removebg-preview.png" alt="Zeynep Arslan" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Zeynep Arslan</div><div className="author-title">Kitora Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#f59e0b"
                        strokeWidth="2"
                        points="0,45 20,42 40,38 60,32 80,28 100,25 120,20 140,15 160,12 180,8 200,5"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Hediyelik ürün pazarında, Ecomverse'un sezonsal kampanya planlaması ve kreatif pazarlama yaklaşımıyla hızlı ölçeklenen bir marka oluşturduk."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-23_at_00.17.44-removebg-preview.png" alt="Doruk Yıldırım" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Doruk Yıldırım</div><div className="author-title">Akme Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#8b5cf6"
                        strokeWidth="2"
                        points="0,50 20,48 40,45 60,40 80,35 100,30 120,25 140,20 160,15 180,10 200,5"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Hayvan ürünleri pazarı duygusal bağ gerektiriyordu. Ecomverse'un topluluk ve marka hikâyesi odaklı pazarlamasıyla güvene dayalı bir müşteri kitlesi oluşturduk."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2026-02-02_at_03.57.53.png-removebg-preview.png" alt="Can Özdemir" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Can Özdemir</div><div className="author-title">PatıcımSpa Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#06d6a0"
                        strokeWidth="2"
                        points="0,48 20,44 40,38 60,30 80,24 100,18 120,14 140,10 160,7 180,4 200,2"
                      />
                    </svg>
                  </div>
                </div>

                {/* Duplicate for seamless loop */}
                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Kitap kitlesine hitap eden bir pazarda, Ecomverse'un içerik odaklı pazarlama ve niş topluluk oluşturma stratejileriyle sadık bir okur müşteri kitlesi yarattık."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-21_at_02.31.32-removebg-preview.png" alt="Emre Yıldız" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Emre Yıldız</div><div className="author-title">Lumipage Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#3b82f6"
                        strokeWidth="2"
                        points="0,50 20,45 40,35 60,25 80,20 100,15 120,10 140,8 160,5 180,3 200,2"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Temizlik ürünleri pazarı yoğun rekabet içindeydi. Ecomverse ile doğru pazar analizi ve performans pazarlaması sayesinde markayı sürdürülebilir satış seviyesine taşıdık."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-23_at_00.10.35__1_-removebg-preview.png" alt="Burak Demir" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Burak Demir</div><div className="author-title">Otowashing Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#10b981"
                        strokeWidth="2"
                        points="0,55 20,52 40,48 60,42 80,35 100,28 120,22 140,18 160,12 180,8 200,5"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Kozmetik sektöründe, Ecomverse'un trend yakalama ve sürdürülebilir pazarlama stratejileriyle hem güven veren hem de karlı bir marka inşa ettik."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-23_at_00.10.35-removebg-preview.png" alt="Zeynep Arslan" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Zeynep Arslan</div><div className="author-title">Kitora Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#f59e0b"
                        strokeWidth="2"
                        points="0,45 20,42 40,38 60,32 80,28 100,25 120,20 140,15 160,12 180,8 200,5"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Hediyelik ürün pazarında, Ecomverse'un sezonsal kampanya planlaması ve kreatif pazarlama yaklaşımıyla hızlı ölçeklenen bir marka oluşturduk."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2025-11-23_at_00.17.44-removebg-preview.png" alt="Doruk Yıldırım" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Doruk Yıldırım</div><div className="author-title">Akme Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#8b5cf6"
                        strokeWidth="2"
                        points="0,50 20,48 40,45 60,40 80,35 100,30 120,25 140,20 160,15 180,10 200,5"
                      />
                    </svg>
                  </div>
                </div>

                <div className="testimonial-card">
                  <div className="testimonial-content">
                    <p className="testimonial-text">
                      "Hayvan ürünleri pazarı duygusal bağ gerektiriyordu. Ecomverse'un topluluk ve marka hikâyesi odaklı pazarlamasıyla güvene dayalı bir müşteri kitlesi oluşturduk."
                    </p>
                  </div>
                  <div className="testimonial-author">
                    <div className="author-avatar">
                      <img src="/images/WhatsApp_Image_2026-02-02_at_03.57.53.png-removebg-preview.png" alt="Can Özdemir" className="avatar-image" />
                    </div>
                    <div className="author-info">
                      <div className="author-name">Can Özdemir</div><div className="author-title">PatıcımSpa Kurucusu</div>
                    </div>
                  </div>
                  <div className="testimonial-chart">
                    <svg viewBox="0 0 200 60" className="chart-svg">
                      <polyline
                        fill="none"
                        stroke="#06d6a0"
                        strokeWidth="2"
                        points="0,48 20,44 40,38 60,30 80,24 100,18 120,14 140,10 160,7 180,4 200,2"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* FAQ Section */}
        <div className="faq-section" id="faq">
          <div className="container-main">
            <div className="faq-header">
              <div className="faq-badge">
                <span className="question-icon">❓</span>
                <span>Sık Sorulanlar</span>
              </div>
              <h2 className="faq-title">Sıkça Sorulan Sorular</h2>
              <p className="faq-subtitle">Hâlâ düşünüyor musunuz?</p>
            </div>

            <div className="faq-container">
              <div className={`faq-item ${openFaqIndex === 0 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(0)}>
                  <span>Katıldığımda tam olarak neye erişeceğim?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>Düzenli olarak güncellenen Ecomverse size sayısız ders ve aktif bir topluluk sunar. E-Ticaret, yapay zeka ve spora dair aklınıza gelen her şeyi sorabilirsiniz.</p>
                </div>
              </div>

              <div className={`faq-item ${openFaqIndex === 1 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(1)}>
                  <span>Ecomverse'a katıldığımda paraya ihtiyacım olacak mı?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>Büyük bir sermayeye ihtiyacınız yok.</p>
                  <p>Biz size tam olarak sıfırdan başlamanız için yardımcı oluyoruz.</p>
                  <p>Her şeyi sıfırdan inşa etmek mümkün.</p>
                </div>
              </div>

              <div className={`faq-item ${openFaqIndex === 2 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(2)}>
                  <span>18 yaşından küçüksem Ecomverse'a katılabilir miyim?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>18 yaşından küçük herkesi Ecomverse'a katılmadan önce bir ebeveyne veya veliye danışmaya teşvik ediyoruz.</p>
                  <p>Sürekli reels izlemek veya bilgisayar oyunları oynamak yerine Ecomverse'a katılabilir, işinizi kurabilir ve gerçek hayatta seviye atlayan çocuk olarak arkadaşlarınızı ve ailenizi şaşırtabilirsiniz.</p>
                </div>
              </div>

              <div className={`faq-item ${openFaqIndex === 3 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(3)}>
                  <span>Paramı ne kadar sürede geri alabilirim?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>Ecomverse'da öğrendiklerinizi uygulayarak ilk aydan itibaren gelir elde etmeye başlayabilirsiniz. Ancak bu tamamen sizin çabanıza ve öğrendiklerinizi ne kadar hızlı uyguladığınıza bağlıdır.</p>
                </div>
              </div>

              <div className={`faq-item ${openFaqIndex === 4 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(4)}>
                  <span>E-Ticaret hakkında hiçbir şey bilmiyorum. Sorun yaşar mıyım?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>Hiç sorun değil! Ecomverse tam olarak sıfırdan başlayanlar için tasarlandı. Adım adım rehberlik ile e-ticaret dünyasına giriş yapacaksınız.</p>
                </div>
              </div>

              <div className={`faq-item ${openFaqIndex === 5 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(5)}>
                  <span>Ecomverse kadınlar için uygun mu?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>Tabii ki! Ecomverse cinsiyet ayrımı yapmadan herkesi kucaklayan bir topluluktur. Kadın girişimciler için de eşit fırsatlar sunuyoruz.</p>
                </div>
              </div>

              <div className={`faq-item ${openFaqIndex === 6 ? 'active' : ''}`}>
                <div className="faq-question" onClick={() => toggleFaq(6)}>
                  <span>Hala sorularınız mı var?</span>
                  <span className="faq-toggle">+</span>
                </div>
                <div className="faq-answer">
                  <p>Başka sorularınız varsa bize info@Ecomverse.co adresinden ulaşabilir veya sosyal medya hesaplarımızdan mesaj gönderebilirsiniz.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            {/* Logo ve Açıklama */}
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/images/logo 1.png" alt="Ecomverse Logo" className="footer-logo-image" />
                <span className="footer-logo-text">Ecomverse</span>
              </div>
              <p className="footer-description">
                Zenginlik için torpil gerekmez. Bilgiye önce ulaşan kazanır. Ecomverse topluluğu ile e-ticaret dünyasında öne geçin.
              </p>
            </div>

            {/* Platform */}
            <div className="footer-section">
              <h3 className="footer-title">Platform</h3>
              <ul className="footer-links">
                <li><a href="#features" className="footer-link">Özellikler</a></li>
                <li><a href="#testimonials" className="footer-link">Mentorlar</a></li>
                <li><a href="#pricing" className="footer-link">Fiyatlandırma</a></li>
                <li><a href="#faq" className="footer-link">SSS</a></li>
              </ul>
            </div>

            {/* Yasal */}
            <div className="footer-section">
              <h3 className="footer-title">Yasal</h3>
              <ul className="footer-links">
                <li><a href="/privacy" className="footer-link">Gizlilik Politikası</a></li>
                <li><a href="/terms" className="footer-link">Kullanım Şartları</a></li>
                <li><a href="/sales-agreement" className="footer-link">Mesafeli Satış Sözleşmesi</a></li>
                <li><a href="/refund" className="footer-link">İptal ve İade</a></li>
              </ul>
            </div>

            {/* İletişim */}
            <div className="footer-section">
              <h3 className="footer-title">İletişim</h3>
              <div className="footer-contact">
                <a href="mailto:info@Ecomverse.co" className="footer-email">info@Ecomverse.co</a>
                <div className="footer-social">
                  <a href="https://www.instagram.com/dorukecom/" className="social-link" aria-label="Instagram">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                  <a href="https://www.tiktok.com/@dorukecom" className="social-link" aria-label="TikTok">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                    </svg>
                  </a>
                  <a href="https://www.youtube.com/@dorukcom" className="social-link" aria-label="YouTube">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                  </a>
                  <a href="https://discord.gg/ecomverse" className="social-link" aria-label="Discord">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="footer-copyright">© 2024 Ecomverse Inc. Tüm hakları saklıdır.</p>
              <div className="footer-made-with">
                <span>Made with</span>
                <span className="john-logo">John</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;







